import React, { useState } from "react";
import { Button, Col, Form, InputGroup, Row, Spinner } from "react-bootstrap";
import PrivateApi from "../../../services/PrivateApiService";
import HoverBadge from "../../shared/HoverBadge";
import { FaSearch } from "react-icons/fa";


/**
 * 
 * @param {props} setStage setter sets stage/view
 * @param {props} setSelectedInvoices setter sets selectedInvoices
 * 
 * @returns ticket mask
 */
const LieferantrechnungTicketStage = ({setStage, selectInvoices}) => {

    const API = new PrivateApi();
    const [selectedInvoices, setSelectedInvoices] = useState([]);
    const [invoiceLoading, setInvoiceLoading] = useState(false);
    const [invoiceNotFound, setInvoiceNotFound] = useState(false);
    const [searchField, setSearchField] = useState("");

    const removeSelectedBadgeHandler = (id) => {
        var tempList = selectedInvoices.filter(si => si.id !== id);
        setSelectedInvoices(tempList);
    }

    const enterHandler = (event) => {
        if (event.key === "Enter") {
            return searchHandler();
        }
    }

    const searchHandler = () => {
        setInvoiceNotFound(false);
        var tempList = [...selectedInvoices];
        var index = tempList.findIndex(i => i.x_rechnungsnummer === searchField);
        if (index === -1) {
            setInvoiceLoading(true);
            API.get_Abrechnung_search({x_rechnungsnummer: searchField})
                .then(res => {
                    setInvoiceLoading(false);
                    let data = res.data;
                    if (data.length === 0) {
                        return setInvoiceNotFound(true);
                    }
                    tempList.push(data);
                    setSelectedInvoices(tempList);
                    setSearchField("");
                })
                .catch(err => {
                    setInvoiceLoading(false);
                })
        }
    }


    return (
        <>
            <h5>Geben Sie die Rechnungsnummer ein</h5>
            <p>Um Ihnen weiterzuhelfen benötigen wir die Rechnungsnummer</p>
            <Row className="mt-5" hidden={selectedInvoices.length === 0}>
                <Col xs="12" className="text-center">
                    <p>Ausgewählte Energielieferant Rechnungen</p>
                    {selectedInvoices !== null && selectedInvoices.length > 0 ? 
                        selectedInvoices.map(i => (
                            <HoverBadge id={i.id} desc={`${i.x_rechnungsnummer}`} remove={removeSelectedBadgeHandler} />
                        ))
                    : null}
                </Col>
            </Row>
            <Row className="mt-5 justify-content-center">
                <Col xs="12" xl="8" className="text-center">
                    <InputGroup>
                        <Form.Control 
                            disabled={invoiceLoading} 
                            onKeyDown={(e) => enterHandler(e)} 
                            onChange={e => setSearchField(e.target.value)}
                            value={searchField}
                            placeholder="Rechnungsnummer"
                        />
                        <Button disabled={invoiceLoading} onClick={() => searchHandler()}><FaSearch/></Button>
                    </InputGroup>
                    <br />
                    <p hidden={!invoiceNotFound}>Die eingegebene Rechnungsnummer konnte nicht gefunden werden.</p>
                </Col>
            </Row>
            <Row className="mt-5 text-center" hidden={!invoiceLoading}>
                <Col xs="12">
                    <Spinner animation="grow" className="text-energo" /> &nbsp;
                    <Spinner animation="grow" className="text-energo" /> &nbsp;
                    <Spinner animation="grow" className="text-energo" /> 
                </Col>
            </Row>
            <Row className="mt-5">
                <Col xs="12" className="text-end">
                    <Button onClick={() => setStage("Rechnung (ENERGO, Lieferantenrechnung)")} variant="warning">Zurück</Button> &nbsp;
                    <Button 
                        onClick={() => {selectInvoices(selectedInvoices); setStage('body')}}
                        hidden={selectedInvoices.length === 0}
                        className="btn-energo"
                    >
                        Weiter
                    </Button>

                </Col>
            </Row>
        </>
    )
}

export default LieferantrechnungTicketStage;